import $ from 'jquery';
import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Accordions from './Accordions';
import Alerts from './Alerts';
import Badges from './Badges';
import Breadcrumbs from './Breadcrumbs';
import ButtonGroups from './ButtonGroups';
import Buttons from './Buttons';
import Cards from './Cards';
import Charts from './Charts';
import Controls from './Controls';
import Dropdowns from './Dropdowns';
import Dropzones from './Dropzones';
import Forms from './Forms';
import Modals from './Modals';
import MoodboardComponent from './MoodboardComponent';
import Navbars from './Navbars';
import Oauths from './Oauths';
import ObjectAttributes from './ObjectAttributes';
import PhotoGalleries from './PhotoGalleries';
import ProgressLoaders from './ProgressLoaders';
import Selects from './Selects';
import SlidesOver from './SlidesOver';
import './StyleGuide.scss';
import Tables from './Tables';
import Tabs from './Tabs';
import Cropper from '../../components/Cropper/Cropper';
import Tooltips from './Tooltips'

const Components = () => {
  useEffect(() => {
    $('#container-components').scrollspy({ target: '#navbar-components' });
  }, []);

  return (
    <Row id="wrapper-components">
      <Col sm={3}>
        <nav id="navbar-components" className="navbar navbar-light bg-light">
          <nav className="nav nav-pills flex-column">
            <a className="nav-link" href="#accordions">Accordions</a>
            <a className="nav-link" href="#alerts">Alerts &amp; Toasts</a>
            <a className="nav-link" href="#badges">Badges</a>
            <a className="nav-link" href="#buttons">Buttons</a>
            <a className="nav-link" href="#button-groups">Button Groups</a>
            <a className="nav-link" href="#breadcrumbs">Breadcrumbs</a>
            <a className="nav-link" href="#cards">Cards</a>
            <a className="nav-link" href="#charts">Charts</a>
            <a className="nav-link" href="#controls">Controls</a>
            <a className="nav-link" href="#cropper">Cropper</a>
            <a className="nav-link" href="#drag-drop">Drag &amp; Drop</a>
            <a className="nav-link" href="#dropdowns">Dropdowns</a>
            <a className="nav-link" href="#forms">Forms</a>
            <a className="nav-link" href="#modals">Modals</a>
            <a className="nav-link" href="#moodboard">Moodboard</a>
            <a className="nav-link" href="#object-attributes">ObjectAttribute</a>
            <a className="nav-link" href="#navbars">Navbars</a>
            <a className="nav-link" href="#oauths">Oauths</a>
            <a className="nav-link" href="#photo-galleries">Photo Gallery</a>
            <a className="nav-link" href="#progress-loaders">Progress &amp; Loaders</a>
            <a className="nav-link" href="#selects">Selects</a>
            <a className="nav-link" href="#slides-over">Slides Over</a>
            <a className="nav-link" href="#tables">Tables</a>
            <a className="nav-link" href="#tabs">Tabs</a>
            <a className="nav-link" href="#tooltips">Tooltips</a>
          </nav>
        </nav>
      </Col>
      <Col sm={9}>
        <Container
          id="container-components"
          className="container-style-guide"
          data-spy="scroll"
          data-target="#navbar-components"
          data-offset="0">

          <Accordions />
          <Alerts />
          <Badges />
          <Buttons />
          <ButtonGroups />
          <Breadcrumbs />
          <Cards />
          <Charts />
          <Controls />
          <Cropper />
          <Dropzones />
          <Dropdowns />
          <Forms />
          <Modals />
          <MoodboardComponent />
          <Navbars />
          <Oauths />
          <ObjectAttributes />
          <PhotoGalleries />
          <ProgressLoaders />
          <Selects />
          <SlidesOver />
          <Tabs />
          <Tables />
          <Tooltips />
        </Container>
      </Col>
    </Row >
  );
};

export default React.memo(Components);
